export default "__VITE_ASSET__DurWNnH8__"